/** Standard backend response envelope: { status, code, message, data, page }. */
export interface ApiEnvelope<T> {
  status: boolean;
  code: number;
  message: string;
  data: T;
  page?: Page;
}

export interface Page {
  total: number;
  per_page: number;
  page_number: number;
  total_page: number;
}

/** Search/order params shared by paginated list endpoints. */
export interface SearchParams {
  per_page?: number;
  page_number?: number;
  search?: Array<{ field: string; value: string | string[] }>;
  order?: Array<{ by: string; type: 'asc' | 'desc' }>;
}

/**
 * Typed API error that preserves the backend `errorCode` string so the UI can
 * branch on specific cases (COUPON_INVALID, capacity blocked, etc.).
 */
export class ApiError extends Error {
  readonly code: number;
  readonly errorCode: string | null;
  readonly isNetwork: boolean;
  /** Raw structured payload (e.g. capacity `{ blocked: true }`). */
  readonly payload: unknown;

  constructor(args: {
    message: string;
    code: number;
    errorCode?: string | null;
    isNetwork?: boolean;
    payload?: unknown;
  }) {
    super(args.message);
    this.name = 'ApiError';
    this.code = args.code;
    this.errorCode = args.errorCode ?? null;
    this.isNetwork = args.isNetwork ?? false;
    this.payload = args.payload;
  }
}
